import { render, staticRenderFns } from "./DonatieBedankt.vue?vue&type=template&id=cb53d2c4&"
import script from "./DonatieBedankt.vue?vue&type=script&lang=js&"
export * from "./DonatieBedankt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports